import React, {FC, createContext, useContext, useEffect, useState} from 'react'
import {QUERIES, WithChildren} from '../helpers'
import {establishOwnerFromDomain} from "../helpers/custom/funcs/establishOwnerFromDomain";
import {getLocalesData, getWebsiteData} from '../../app/modules/general/core/_requests'
import {useQuery} from 'react-query'
import {getPhoneCodes} from '../../app/modules/auth/core/_requests'
import {IWD} from '../layout/core'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: string
  setLanguage: (lang: string) => void
  locales: string[]
  initLocales: (websiteData: IWD) => void
}

const initialState = {
  selectedLang: 'uk',
  setLanguage: () => {},
  locales: ['uk', 'ru'],
  initLocales: () => {},
}

function langIsSet() {
  return !!localStorage.getItem(I18N_CONFIG_KEY)
}

export function getConfig():Pick<Props, 'selectedLang'> {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return {selectedLang: initialState.selectedLang}
}

function getLangFromUrlParam(): string | null {
  const url = new URL(window.location.href)
  const urlParams = url.searchParams
  const langParam = urlParams.get('lang')

  if (langParam) {
    urlParams.delete('lang')
    const newUrl = url.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '') + url.hash
    window.history.replaceState({}, document.title, newUrl)
  }

  return langParam
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}
const useI18n = () => {
  return useContext(I18nContext)
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const {selectedLang} = getConfig()
  const [locale, setLocale] = useState<string>(selectedLang)
  const [locales, setLocales] = useState<string[]>(initialState.locales)

  const setLanguage = (lang:string) => {
    localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
    setLocale(lang)
    console.log('ls', lang)
  }
  const initLocales = (websiteData:IWD) => {
    const urlLang = getLangFromUrlParam()
    if (!langIsSet()) {
      if (urlLang && websiteData.enabledLocales.includes(urlLang)) {
        setLanguage(urlLang)
      } else {
        setLanguage(websiteData.mainLocale)
      }
    }
    setLocales(websiteData.enabledLocales)
  }

  return <I18nContext.Provider value={{selectedLang: locale, setLanguage, locales, initLocales}}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang, useI18n}
